const roleTypes = [
    { name: "Admin", value: "Admin" },
    { name: "User", value: "User" },
  ];

export {roleTypes}